import script from "./StaffSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffSearch.vue?vue&type=script&setup=true&lang=js"

import "./StaffSearch.vue?vue&type=style&index=0&id=d88d3d8c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d88d3d8c"]])

export default __exports__